// @ts-check
/**
 * Country dropdown shared by the event form (variant "full", shows the name), and the lead and POS
 * phone capture (variant "phone", shows "flag +91" compactly beside the number input).
 * It is a native select, so a phone shows its own big picker; in the phone variant the select is
 * laid transparently over a short label so only "flag +91" takes up room.
 */
import { COUNTRIES, countryByIso } from '../utils/countries';

/**
 * @param {{value: string, onChange: (iso: string) => void, variant?: 'phone' | 'full', ariaLabel?: string, className?: string}} props
 */
const CountrySelect = ({ value, onChange, variant = 'full', ariaLabel = 'Country', className = '' }) => {
  const selected = countryByIso(value);

  const options = COUNTRIES.map((c) => (
    <option key={c.iso} value={c.iso}>
      {variant === 'phone' ? `${c.flag} ${c.name} (${c.dial})` : `${c.flag} ${c.name}`}
    </option>
  ));

  if (variant === 'phone') {
    return (
      <div
        className={`relative shrink-0 w-28 border border-input rounded-lg bg-card focus-within:ring-2 focus-within:ring-foreground ${className}`}
      >
        <span className="flex items-center justify-center gap-1 h-full px-2 py-3 text-base pointer-events-none whitespace-nowrap">
          {selected ? `${selected.flag} ${selected.dial}` : 'Code'}
        </span>
        <select
          aria-label={ariaLabel}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer text-base"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {!selected && <option value="">Choose</option>}
          {options}
        </select>
      </div>
    );
  }

  return (
    <select
      aria-label={ariaLabel}
      className={`w-full px-3 py-2 text-base border border-input rounded-lg ${className}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {!selected && <option value="">Choose the country...</option>}
      {options}
    </select>
  );
};

export default CountrySelect;
